<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 20%">
                            <CCol sm="8" style="width: 100%;background-size: cover; margin: auto;">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Verification</h3>
                                        <p class="custom-16px-400">Please confirm your email address by clicking the Verify Email button on following below. This step is essential to 
                                            complete your registration and ensure the security of your account.</p>
                                    </div>
                                    <div class="mt-3">
                                        
                                        <!-- Column for mobile view -->
                                       
                                    </div>
                                    <div style="clear:both"></div>
                                    <div class="text-center mt-5">
                                        <span class="custom-border-purple p-2 text-center text-white" v-on:click="ValidateCode">
                                                            <label class="ml-2 mr-2">Verify Email</label></span>
                                        <br />
                                    </div>
                                </CCard>
                            </CCol>
                        </div>
    
    
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Save Successfully
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
    </div>
</template>


<script>
import Vue from "vue";
//import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '20319378015-mf0mi472v5n6i9926q0nkgf6jqrj9tgv.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isPopupSuccess: false,





        };
    },


    methods: {
        ValidateCode() {
            return this.$API
                .get(this.$ValidateEmail + "/" + this.$route.query.code)
                .then((response) => {
                    if (response.status == 200) {
                        //this.isPopupSuccess = true;
                       this.$router.push("Login");
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
            this.$router.push("Login");

        }



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>